import * as types from './mutation-types'

const mutations = {
   
    [types.TOGGLE_SIDEBAR](state, sidebar) {
        state.sidebar = sidebar
    },
    [types.CHANGE_THEME](state, themeValue) {
        state.themeValue = themeValue
    },
   
    [types.UPDATE_MENUS](state, menus) {
        state.menus = [...menus]
    },
    [types.UPDATE_TOKEN](state, token) {
        window.localStorage.setItem('token', token)
        state.token = token
    },
    [types.UPDATE_USERINFO](state, userInfo) {
        state.userInfo = Object.assign(state.userInfo, userInfo)
    },
 
}

export default mutations